import AccountBalancesRoutes from './accountBalances.js';
import AccountStatementGenerator from './AccountStatementGenerator.js';
import AccountStatementTransactionsRoutes from './accountStatementTransactions.js';
import adjustmentsRoutes from './adjustments.js';
import auditLogsRoutes from './auditLogs.js';
import auth from './auth.js';
import banksRoutes from './banks.js';
import channelsRoutes from './channels.js';
import citiesRoutes from './cities.js';
import complianceRoutes from './compliance.js';
import customerPortalUsersRoutes from './customerPortalUsers.js';
import DevicesRoutes from './devices.js';
import externalDocuments from './externalDocuments.js';
import financeReconTool from './financeReconTool.js';
import healthDashboardRoutes from './healthDashboard.js';
import integrationLogsRoutes from './integrationLogs.js';
import LoansRoutes from './loans.js';
import merchantsRoutes from './merchants.js';
import merchantsRequestsRoutes from './merchantsRequests.js';
import MonitoringDashboard from './monitoringDashboard.js';
import MT940StatementsRoutes from './MT940Statemnets.js';
import MT942StatementsRoutes from './MT942Statemnets.js';
import nafathViewRoutes from './nafathView.js';
import onboardRequestsRoutes from './onboardRequests.js';
import partnersRoutes from './partners.js';
import paymentsRoutes from './payments.js';
import reconciliationRoutes from './reconciliation.js';
import reportsRoutes from './reports.js';
import requestsRoutes from './requests.js';
import subscriptionsRoutes from './subscriptions.js';
import SupplyRoutes from './supply.js';
import TerminalReconRoutes from './terminalRecon.js';
import TerminalRegistrationRoutes from './terminalRegistration.js';
import TerminalRoutes from './terminals.js';
import TIDRoutes from './tid.js';
import transactionsRoutes from './transactions.js';
import usersRoutes from './userManagement.js';
import vatRoutes from './vat.js';

const Dashboard = () => import('../screens/Dashboard/DashboardView.vue');
const NotFound = () => import('../screens/NotFound.vue');
const Unauthorized = () => import('../screens/UnauthorizedView.vue');

export default [
  {
    path: '/',
    redirect: '/merchants',
  },
  ...auth,
  ...merchantsRoutes,
  ...merchantsRequestsRoutes,
  ...banksRoutes,
  ...AccountBalancesRoutes,
  ...AccountStatementTransactionsRoutes,
  ...channelsRoutes,
  ...paymentsRoutes,
  ...transactionsRoutes,
  ...adjustmentsRoutes,
  ...subscriptionsRoutes,
  ...usersRoutes,
  ...requestsRoutes,
  ...auditLogsRoutes,
  ...integrationLogsRoutes,
  ...citiesRoutes,
  ...vatRoutes,
  ...onboardRequestsRoutes,
  ...customerPortalUsersRoutes,
  ...complianceRoutes,
  ...reportsRoutes,
  ...reconciliationRoutes,
  ...healthDashboardRoutes,
  ...MT940StatementsRoutes,
  ...externalDocuments,
  ...MT942StatementsRoutes,
  ...partnersRoutes,
  ...financeReconTool,
  ...TerminalRegistrationRoutes,
  ...nafathViewRoutes,
  ...DevicesRoutes,
  ...TerminalRoutes,
  ...TIDRoutes,
  ...TerminalReconRoutes,
  ...LoansRoutes,
  ...MonitoringDashboard,
  ...AccountStatementGenerator,
  ...SupplyRoutes,
  {
    component: Dashboard,
    meta: {
      activeSidebarItemId: 'dashboard',
      pageTitle: 'Dashboard',
    },
    name: 'dashboard',
    path: '/dashboard',
  },
  {
    component: NotFound,
    meta: {
      pageTitle: 'Page Not Found',
    },
    name: '404',
    path: '/404',
  },
  {
    component: Unauthorized,
    meta: { pageTitle: 'Unauthorized' },
    name: 'unauthorized',
    path: '/unauthorized',
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/404',
  },
];
